export class Mutex<T> {
    private waiting: {
        resolve: (value: T | PromiseLike<T>) => void,
        reject: (reason?: any) => void
    }[] = [];
    private value!: T | PromiseLike<T>;

    public async await(): Promise<T> {
        if (this.value) return Promise.resolve(this.value);

        return new Promise((resolve, reject) => {
            this.waiting.push({ resolve, reject });
        });
    }

    public ready(value?: T, error?: Error): void {
        if (error)
            return this.waiting.forEach(p => p.reject(error))

        this.waiting.forEach(p => p.resolve(this.value));
    }
}